// 전처리 옵션
export const previewOptionUpdate = {
  input: { para: { mode: "backup" } },
  detect_linear: { para: { mode: "disabled" } },
  detect_hori: { para: { mode: "disabled" } },
  detect_verti: { para: { mode: "disabled" } },
  ignore_dot: { para: { mode: "disabled" } },
  detect_innerDust: { para: { mode: "disabled" } },
  detect_edgeCrash: { para: { mode: "disabled" } },
  detect_outer: { para: { mode: "disabled" } },
  ignore_rotNbrightNcont: { para: { mode: "disabled" } },
  expanddim: { para: { mode: "disabled" } },
  model1: { para: { mode: "show" } },
  matscore: { para: { mode: "disabled" } },
  makescoremap: { para: { mode: "disabled" } },
  data2bytes: { para: { mode: "enabled" } },
};

// 전처리 히트맵 옵션
export const previewHeatmapOptionUpdate = {
  input: { para: { mode: "backup" } },
  makemat: { para: { mode: "disabled" } },
  augment_poly: { para: { mode: "disabled" } },
  augment_line: { para: { mode: "disabled" } },
  augment_para: { para: { mode: "disabled" } },
  mergelabel: { para: { mode: "disabled" } },
  model1: { para: { mode: "infer" } },
  matscore: { para: { mode: "enabled" } },
  makescoremap: { para: { mode: "enabled" } },
  data2bytes: { para: { mode: "enabled" } },
};

// 학습 옵션
export const trainOptionUpdate = {
  input: { para: { mode: "enabled" } },
  detect_linear: { para: { mode: "enabled" } },
  detect_hori: { para: { mode: "enabled" } },
  detect_verti: { para: { mode: "enabled" } },
  ignore_dot: { para: { mode: "enabled" } },
  detect_innerDust: { para: { mode: "enabled" } },
  detect_edgeCrash: { para: { mode: "enabled" } },
  detect_outer: { para: { mode: "enabled" } },
  ignore_rotNbrightNcont: { para: { mode: "enabled" } },
  expanddim: { para: { mode: "enabled" } },
  model1: { para: { mode: "train" } },
  matscore: { para: { mode: "disabled" } },
  makescoremap: { para: { mode: "disabled" } },
  data2bytes: { para: { mode: "disabled" } },
};

// 검증 옵션
export const validOptionUpdate = {
  input: { para: { mode: "enabled" } },
  detect_linear: { para: { mode: "disabled" } },
  detect_hori: { para: { mode: "disabled" } },
  detect_verti: { para: { mode: "disabled" } },
  ignore_dot: { para: { mode: "disabled" } },
  detect_innerDust: { para: { mode: "disabled" } },
  detect_edgeCrash: { para: { mode: "disabled" } },
  detect_outer: { para: { mode: "disabled" } },
  ignore_rotNbrightNcont: { para: { mode: "disabled" } },
  expanddim: { para: { mode: "disabled" } },
  model1: { para: { mode: "infer" } },
  matscore: { para: { mode: "enabled" } },
  makescoremap: { para: { target_labels: ["NG"], mode: "enabled" } },
  data2bytes: { para: { mode: "disabled" } },
};

// heatmap 옵션
export const scoremapOptionUpdate = {
  input: { para: { mode: "backup" } },
  detect_linear: { para: { mode: "disabled" } },
  detect_hori: { para: { mode: "disabled" } },
  detect_verti: { para: { mode: "disabled" } },
  ignore_dot: { para: { mode: "disabled" } },
  detect_innerDust: { para: { mode: "disabled" } },
  detect_edgeCrash: { para: { mode: "disabled" } },
  detect_outer: { para: { mode: "disabled" } },
  ignore_rotNbrightNcont: { para: { mode: "disabled" } },
  expanddim: { para: { mode: "disabled" } },
  model1: { para: { mode: "infer" } },
  matscore: { para: { mode: "enabled" } },
  makescoremap: { para: { target_labels: [], mode: "enabled" } },
  data2bytes: { para: { mode: "disabled" } },
};

// ai module option change 함수
export const coerceByTemplate = (templateVal, newVal) => {
  // 배열
  if (Array.isArray(templateVal)) {
    // newVal도 배열이면 각 요소를 템플릿 요소 타입에 맞춰 보정
    if (Array.isArray(newVal)) {
      const unitTemplate = templateVal[0]; // 요소의 템플릿
      const coerced = newVal.map((v) => coerceByTemplate(unitTemplate, v));
      // 길이를 템플릿 길이에 맞추고 싶다면 다음 두 줄 활성화:
      // if (templateVal.length > 0) coerced.length = templateVal.length;
      return coerced;
    }
    // 스칼라를 받았으면 배열로 감싸서 보정 (길이 1 유지)
    const unitTemplate = templateVal[0];
    return [coerceByTemplate(unitTemplate, newVal)];
  }

  // 객체(중첩) - 깊은 병합
  if (templateVal && typeof templateVal === "object") {
    return mergePreservingTypes(templateVal, newVal || {});
  }

  // 숫자
  if (typeof templateVal === "number") {
    const n = Number(newVal);
    return Number.isFinite(n) ? n : templateVal;
  }

  // 불리언
  if (typeof templateVal === "boolean") {
    if (typeof newVal === "boolean") return newVal;
    if (newVal === "true") return true;
    if (newVal === "false") return false;
    return !!templateVal;
  }

  // 문자열 (그 외는 문자열화)
  if (typeof templateVal === "string") {
    return newVal == null ? "" : String(newVal);
  }

  // 템플릿이 비어있다면 새 값 그대로
  return newVal;
};

// 템플릿 구조를 보존하며 updates를 병합
export const mergePreservingTypes = (templateObj, updatesObj) => {
  const out = Array.isArray(templateObj) ? [] : {};
  const keys = new Set([
    ...Object.keys(templateObj || {}),
    ...Object.keys(updatesObj || {}),
  ]);
  for (const k of keys) {
    const tVal = templateObj?.[k];
    const uVal = updatesObj?.[k];
    if (tVal === undefined) {
      // 템플릿에 없는 새 필드는 그대로 추가 (원치 않으면 건너뛰기)
      out[k] = uVal;
    } else if (uVal === undefined) {
      // 업데이트 없으면 템플릿 유지
      out[k] = tVal;
    } else {
      out[k] = coerceByTemplate(tVal, uVal);
    }
  }
  return out;
};

// overkill 변환 함수
export const computeOverkill = (validDataset, thresholdFromModule) => {
  const OKList = [];
  const NGList = [];

  for (const pack of validDataset ?? []) {
    if (!pack) continue;

    const score = Number(pack.score);
    if (!Number.isFinite(score)) continue;

    const label = String(pack.label ?? "").toUpperCase();

    if (label === "OK") {
      OKList.push(score);
    } else if (label === "NG") {
      NGList.push(score);
    }
  }
  let threshold = Number(thresholdFromModule);

  if (!Number.isFinite(threshold)) {
    threshold = NGList.length > 0 ? Math.min(...NGList) : undefined;
  }

  let overkillRate = 0;

  if (OKList.length > 0 && Number.isFinite(threshold)) {
    const okOver = OKList.filter((s) => s >= threshold).length;
    overkillRate = okOver / OKList.length;
  }

  return {
    OKList,
    NGList,
    threshold,
    overkillRate, // 0~1
    overkillPercent: (overkillRate * 100).toFixed(2) + "%",
  };
};
